
export class PublishedReportCountsByYear {
  reportYear: number;
  requiredPublicReportCount: number;
  requiredInternalReportCount: number;
  voluntaryPublicReportCount: number;
  voluntaryInternalReportCount: number;
}
//Used for Analytics module
export class ReportCountByStatus {
  isRequired: boolean;
  notStarted: number;
  draft: number;
  submittedToPostApprover: number;
  approvedAndSentToWashington: number;
  returnedFromPostApprover: number;
  returnedFromWashington: number;
  validated: number;
  published: number;
  hold: number;
}
export class ReportCountByType {
  reportYear: number;
  requiredPublicReportCount: number;
  requiredInternalReportCount: number;
  voluntaryPublicReportCount: number;
  voluntaryInternalReportCount: number;
}
export class ReportFilter
{
  fromDate:Date;
  toDate:Date;
  selectedReportCategories:number[] =new Array<number>();  
  selectedCountries:number[] =new Array<number>();
  selectedPosts:string[]=new Array<string>();
  selectedProgramAreas: number[]= new Array<number>();
  selectedReportYears: number[]=new Array<number>();
  selectedReportTypes: number[]=new Array<number>();
  selectedReportDistributionTypes: number[]=new Array<number>();
  
}
export class DownloadCountsReportResult
{
  reportNumber:string;
  reportName:string;
  reportYear:number;
  country:string;
  post:string;
  programArea:string;
  reportCategory:string;
  reportType:string;
  distributionType:string;
  reportDueDate:Date;
  reportPublishDate:Date;
  downloadcounts:number;

}
export class VarianceReportByDueDatesResult
{
  reportNumber:string;
  reportName:string;
  reportYear:number;
  country:string;
  post:string;
  programArea:string;
  reportCategory:string;
  reportType:string;
  distributionType:string;
  reportDueDate:Date;  
  dateSubmittedToWashington:Date;
  submittedDateVariance:string;
  publishedDate:Date;
  publishDateVariance:string;  
  type:string;  
}


export class SubmittedReportCountByPostAndYearResult {
  
  reportYear: number;
  countryName: string;
  postName: string;
  requiredReportCount: number;
  voluntaryReportCount: number;
  totalReportCount: number;
}
export interface GraphData{
  //hc-key:string;
  code3:string;
  name:string;
  value:number;
  requiredCnt:number;
  voluntaryCnt:number;
}